import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { Tooltip } from '.'
import classNames from 'classnames'
import { WeightIcon } from 'lucide-react'

const DEVICE_TYPE_IMG = {
    snaptrap: require('../../../../assets/img/product-logos/snaptrap.png'),
    movement: require('../../../../assets/img/product-logos/movement.png'),
    insect: require('../../../../assets/img/product-logos/insect.png'),
    bait: require('../../../../assets/svg/weight.svg')
}

const SIZES = {
    small: 22,
    regular: 24,
    big: 30
}

const getTooltipText = locale =>
    locale
        ? {
              snaptrap: locale.devices.snaptrapModeTooltip,
              movement: locale.devices.movementModeTooltip,
              insect: locale.devices.insectModeTooltip,
              bait: locale.devices.baitModeTooltip
          }
        : {}

const useStyles = makeStyles(() => ({
    deviceTypeLogo: {
        width({ size }) {
            return SIZES[size] || SIZES.regular
        }
    }
}))

export const OperationModeIcon = ({
    size = 'regular',
    operationMode,
    locale,
    className
}) => {
    const cls = useStyles({ size })

    const tooltipText = useMemo(() => getTooltipText(locale)[operationMode], [
        locale
    ])

    return (
        <Tooltip hover text={tooltipText}>
            <img
                className={classNames(cls.deviceTypeLogo, className)}
                src={DEVICE_TYPE_IMG[operationMode]}
            />
        </Tooltip>
    )
}
